import { unitDefault, unitTypes } from "@/settings/unitTypes";
export const HeatExchangerHeater = {
  id: "71",
  name: "Intercambiador de Calor",
  mainClass: "Estático",
  subtype: "Heater",
  variables: [
    {
      type: unitTypes.temperature,
      unit: unitDefault.temperature.metric,
      code: "heatExchangerShellTemperatureIn",
      groups: "general",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      type: unitTypes.temperature,
      unit: unitDefault.temperature.metric,
      code: "heatExchangerShellTemperatureOut",
      groups: "general",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      type: unitTypes.temperature,
      unit: unitDefault.temperature.metric,
      code: "heatExchangerTubesTemperatureIn",
      groups: "general",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      type: unitTypes.temperature,
      unit: unitDefault.temperature.metric,
      code: "heatExchangerTubesTemperatureOut",
      groups: "general",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      type: unitTypes.temperature,
      unit: unitDefault.temperature.metric,
      code: "heatExchangerLogMeanTemperatureDifference",
      groups: "general",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    }
  ],
  operationalValues: [
    {
      value: 0,
      type: unitTypes.temperature,
      unit: unitDefault.temperature.metric,
      code: "heatExchangerOperationalShellTemperature"
    },
    {
      value: 0,
      type: unitTypes.temperature,
      unit: unitDefault.temperature.metric,
      code: "heatExchangerDesignShellTemperature"
    },
    {
      value: 0,
      type: unitTypes.pressure,
      unit: unitDefault.pressure.metric,
      code: "heatExchangerDesignShellPressure"
    },
    {
      value: 0,
      type: unitTypes.pressure,
      unit: unitDefault.pressure.metric,
      code: "heatExchangerOperationalShellPressure"
    },
    {
      value: 0,
      type: unitTypes.temperature,
      unit: unitDefault.temperature.metric,
      code: "heatExchangerOperationalTubesTemperature"
    },
    {
      value: 0,
      type: unitTypes.temperature,
      unit: unitDefault.temperature.metric,
      code: "heatExchangerDesignTubesTemperature"
    },
    {
      value: 0,
      type: unitTypes.pressure,
      unit: unitDefault.pressure.metric,
      code: "heatExchangerDesignTubesPressure"
    },
    {
      value: 0,
      type: unitTypes.pressure,
      unit: unitDefault.pressure.metric,
      code: "heatExchangerOperationalTubesPressure"
    },
    {
      value: 0,
      type: unitTypes.power,
      unit: unitDefault.power.metric,
      code: "heatExchangerHeatCapacity"
    }
  ]
};
